module.exports = __webpack_public_path__ + "img/status1.2e614293.png";